<template>
  <div>
    <h2 class="seccion text-primary-dark">
      Mis proyectos
      <router-link to='/proyectos/nuevo' class="d-none d-md-inline-block btn btn-primary float-right"><font-awesome-icon icon="plus"/> Solicitar Proyecto</router-link>
      <router-link to='/proyectos/nuevo' class="d-inline-block d-md-none btn btn-sm btn-primary float-right mt-0">Solicitar</router-link>
    </h2>
    <lista-proyectos :loading="loading" :proyectos="proyectos" @proyecto-seleccionado="goToProyecto($event)"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import ListaProyectos from '@/components/widgets/proyectos/ListaProyectos'

export default {
  data() {
    return {
      loading: false,
      sortKey: 'oportunidad.fechaApertura',
      reverse: true
    }
  },
  computed: {
    ...mapGetters({
      proyectos: 'proyectos',
      urlBase: 'urlBase',
      credentials: 'credentials',
      estados: 'estados'
    })
  },
  mounted() {
    this.loadProyectos();
  },
  methods: {
    loadProyectos() {
      if (this.proyectos == 0) { 
        this.loading = true;
      }
      let grupos = [
        'oportunidad.etapa',
        'oportunidad.ramo'
      ]
      let payload = {
        params: {
          'grupos': grupos.join(','),
          'estados': '1',
          'sort': 'oportunidad.fechaApertura',
          'inverse': 'true',
          'page': 1,
          'limit': 50
        },
        callbackOk: (responses) => {
          this.loading = false
        },
        callbackError: (error) => {
          this.loading = false;
          if (error.status === 401) {
            this.$router.push({name:'Login'});
          }
        }
      }
      this.$store.dispatch("loadProyectos", payload);
    },
    goToProyecto(proyecto) {
      this.$router.push({ name: 'proyecto', params: { id: proyecto.id }});
    }
  },
  components: {
    Loading,
    LogoCia,
    ListaProyectos
  }
}
</script>

